import { CmsActivityHighlightContainerModel } from '../../../../../../models/aggregates/cms/activity/cms-activity-highlight-container.model';
import { CmsActivityHighlightWithActivityContainerModel } from '../../../../../../models/aggregates/cms/activity/cms-activity-highlight-with-activity-container.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Core2Config } from '../../shared';
import { ApiVisa } from '../../shared/api-visa.model';
import { Pagination } from '../../shared/pagination.model';
import { PagingResponseModel } from '../../shared/api-response.model';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({
    providedIn: 'root'
})
export class CmsActivityHighlightService extends BaseApiPublicLoginTemplateService<CmsActivityHighlightContainerModel, CmsActivityHighlightContainerModel, CmsActivityHighlightContainerModel> {

    static readonly ACTIVITY_HIGHLIGHT_SUB_PATH = 'activity-highlights/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + CmsActivityHighlightService.ACTIVITY_HIGHLIGHT_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + CmsActivityHighlightService.ACTIVITY_HIGHLIGHT_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
        this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + CmsActivityHighlightService.ACTIVITY_HIGHLIGHT_SUB_PATH + BaseApiPublicLoginTemplateService.PUBLIC_EP;
        this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + CmsActivityHighlightService.ACTIVITY_HIGHLIGHT_SUB_PATH + BaseApiPublicLoginTemplateService.LOGIN_EP;
        this.httpClient = http;
    }

    /**
     * Calls /public-ep/with-activity/query which returns bl_cms_activity_highlight joined with
     * bl_cms_activities_hdr (only ACTIVE activities). Pass date_from/date_to covering the
     * current week as ConditionalCriteria on the Pagination object.
     */
    public getWeekHighlightsWithActivity(
        pagination: Pagination,
        visa: ApiVisa
    ): Observable<PagingResponseModel<CmsActivityHighlightWithActivityContainerModel>> {
        const url = visa.api_domain_url
            ? visa.api_domain_url
                + Core2Config.TENANT_DOMAIN_URL_PREFIX
                + Core2Config.CMS_PREFIX
                + CmsActivityHighlightService.ACTIVITY_HIGHLIGHT_SUB_PATH
                + 'public-ep/with-activity'
            : this.apiUrl;
        return this.__getByCriteriaAux<CmsActivityHighlightWithActivityContainerModel>(url, pagination, visa);
    }
}
